import * as form from '../form';

export const legalTechnologyProtectedUnauthorized = (data = {}) => {
  const items = ((data.List || {}).items || []).map((x) => {
    const xitem = x.Item || {};
    return {
      Item: {
        Date: form.datecontrol(xitem.Date),
        Incident: form.textarea(xitem.Incident),
        Location: form.location(xitem.Location),
        Action: form.textarea(xitem.Action),
        ProtectedInformationAccessLocation: form.checkboxgroup(xitem.ProtectedInformationAccessLocation), // PVQOnly
        AccessAttemptOutcome: form.branch(xitem.AccessAttemptOutcome), // PVQOnly
        AccessAttemptReason: form.textarea(xitem.AccessAttemptReason), // PVQOnly
        AccessAttemptDisciplinaryAction: form.checkboxgroup(xitem.AccessAttemptDisciplinaryAction), // PVQOnly
        DisciplinaryActionExplanation: form.textarea(xitem.DisciplinaryActionExplanation), // PVQOnly
        DisciplinaryActionOtherExplanation: form.textarea(xitem.DisciplinaryActionOtherExplanation), // PVQOnly
      },
    };
  });
  return {
    HasProtectedUnauthorized: form.branch(data.HasProtectedUnauthorized),
    List: form.collection(items, (data.List || {}).branch),
  };
};
